export default __webpack_public_path__ + "static/media/Harness of Writhing.ad42a8a5.jpg";